export interface RoleSelection {
    role: Role;
    selected: boolean;
}
export interface Role {
    ID: number;
    NAME: string;
    DESCRIPTION: string;
    ACTIVE: number;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    ACCOUNT_REQUEST_ROLES: any[];
    PRIVILEGE_FEATURES: any[];
    TRANSITIONS: any[];
    USER_ROLES: any[];
    WORKFLOW_STATE_ROLES: any[];
}

export function compareRole(r1: Role, r2: Role) {
    const compare = r2.ID - r1.ID;

    if (compare < 0) {
        return 1;
    } else if (compare > 0) {
        return -1;
    } else return 0;
}
